import cn from 'classnames';
import buttonStyles from '../Button.module.css';
import styles from './InlineButton.module.css';

type Props = React.ComponentPropsWithRef<'button'> & {
  /** Optional classes to apply to the button */
  className?: string;
};

/**
 * {@link InlineButton} is a <button> element which is styled as an anchor tag, and thus can be used inline with other text.
 */
export const InlineButton = ({ children, className, ...props }: Props) => {
  const classes = cn('btn a', buttonStyles.Button, styles.InlineButton, className);

  return (
    <button className={classes} type="button" {...props}>
      {children}
    </button>
  );
};
